import { ReactElement, useEffect, useState } from "react";
import "./index.css";
import { Modal } from "../Modal";
import { IAnswer } from "../../type";
import { sanitizeLessonText } from "../../utils/sanitizeLessonText";

interface IProps {
  id?: number;
  title?: string;
  answer: IAnswer[];
  onClickNextEx: (
    passed: boolean,
    answer: string,
    noSendToServer?: boolean
  ) => void;
}

export function AnswerLesson(props: IProps): ReactElement {
  const [value, setValue] = useState<string>("");
  const [showModal, setShowModal] = useState<boolean>(false);
  const [completed, setCompleted] = useState<boolean>(false);

  useEffect(() => {
    if (!(props.answer.filter((a) => a.passed === false).length === 0)) {
      props.answer.sort((a, b) => a.id - b.id);
      setValue(props.answer[props.answer.length - 1].answer);
      setCompleted(true);
    }
  }, [props.answer]);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setValue(e.target.value);
  };

  const safeTitle = sanitizeLessonText(props.title);
  const safeValue = sanitizeLessonText(value);

  return (
    <>
      <div className="textConteiner">
        <h2>{safeTitle}</h2>
        {completed === true ? (
          <p>{safeValue}</p>
        ) : (
          <textarea
            className="textAnswer"
            name="answer"
            rows={20}
            value={value}
            onChange={handleChange}
            placeholder="Ваш ответ"
          ></textarea>
        )}
      </div>
      <div className="onwardBtnLess">
        {completed === true ? (
          <div
            className="completeButton"
            onClick={() => props.onClickNextEx(false, value, true)}
          >
            Завершить
          </div>
        ) : (
          <>
            <div
              className="mainContentSurveyLesson-skipButton"
              onClick={() => {
                setShowModal(true);
              }}
            >
              Пропустить
            </div>

            {value.length < 10 ? (
              <>
                <div
                  className="mainContentSurveyLesson-sendButton dispnon"
                  onClick={() => setShowModal(true)}
                >
                  Отправить
                </div>
              </>
            ) : (
              <>
                <div
                  className="mainContentSurveyLesson-sendButton"
                  onClick={() => {
                    props.onClickNextEx(false, value);
                  }}
                >
                  Отправить
                </div>
              </>
            )}
          </>
        )}

        {showModal && (
          <Modal
            onClickLeft={() => {
              setShowModal(false);
            }}
            text={"Пропустишь — и потеряешь дополнительное вознаграждение!"}
            onClickRight={() => {
              props.onClickNextEx(true, "");
            }}
            textBtnLeft={"Вернуться"}
            textBtnRight={"Завершить"}
          />
        )}
      </div>
    </>
  );
}
